export enum Keys {
  ACCOUNT_CREATOR = '@mlabs-new-user-form',
  COUPON_CODE = '@mlabs-coupon-code',
}
